"use client";

import {TextField, InputAdornment, useTheme, Box} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

export default function SearchBar() {
    const theme = useTheme();

    return (
        <Box style={{ width: "100%", maxWidth: "600px", margin: "auto" }}>
            <TextField
                fullWidth
                placeholder="Search in authors, abstracts, keywords, DOI or etc..."
                variant="outlined"
                size="small"
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <SearchIcon style={{ color: theme.palette.custom?.homeSearchIconColor }} />
                        </InputAdornment>
                    ),
                    style: {
                        backgroundColor: theme.palette.custom?.homeSearchBg,
                        borderRadius: "30px",
                        paddingLeft: "10px",
                    },
                }}
                sx={{
                    "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                            borderColor: theme.palette.custom?.border,
                        },
                        "&:hover fieldset": {
                            borderColor: theme.palette.custom?.homeSearchFocusBorder,
                        },
                        "&.Mui-focused fieldset": {
                            borderColor: theme.palette.custom?.homeSearchFocusBorder,
                        },
                    },
                }}
            />
        </Box>
    );
}
